/* eslint-disable no-new */
import Vue from 'vue/dist/vue.esm';
import VueResource from 'vue-resource';

import JsonApiUrl from '../../00-foundation/00-utils/json-api-endpoint';
import { EventBus, requestHeaders } from '../../configuration';

const urlBuilder = new JsonApiUrl.Builder('node', 'case_study')
  .withIncludes(['field_category_industry', 'field_tile_image', 'field_tile_image.field_media_image'])
  .sortBy(['field_weight'])
  .paginate(15)
  .withFields({});

/* global drupalSettings */
if (typeof drupalSettings !== 'undefined' && drupalSettings.path !== 'undefined') {
  const { currentLanguage } = drupalSettings.path;
  if (currentLanguage) {
    urlBuilder.filterByLanguage(currentLanguage);
  }
}
const caseStudyEndpoint = urlBuilder.build().toString();

const itemsDisplayed = 15;

Vue.use(VueResource);
[...document.querySelectorAll('[data-component="case-study-grid"]')].forEach(el => {
  const categoryIndustry = el.dataset.categoryIndustry === undefined ? FALSE : el.dataset.categoryIndustry;

  new Vue({
    el,
    data() {
      return {
        modifiedData: [],
        items: [],
        itemsDisplayed,
        loadMoreIsDisabled: false,
        selectedCategory: 'all',
        themeColours: ['primary', 'secondary', 'tertiary'],
      };
    },

    methods: {
      getItemLink(item) {
        return item.attributes.path && item.attributes.path.alias
          ? item.attributes.path.alias
          : `/node/${item.attributes.drupal_internal__nid}`;
      },

      setThemeColour() {
        return this.themeColours[Math.floor(Math.random() * this.themeColours.length)];
      },

      getImageTileInformation(item) {
        const imageId = item.relationships.field_tile_image.data && item.relationships.field_tile_image.data.id;

        const imageData = {};

        const mediaImageId = this.included.filter(itemData => {
          return itemData.id === imageId;
        })[0];

        if (mediaImageId && mediaImageId.relationships.field_media_image.data.meta.alt) {
          imageData.alt = mediaImageId.relationships.field_media_image.data.meta.alt;
        }

        if (mediaImageId && mediaImageId.relationships.field_media_image.data.id) {
          const mediaFile = this.included.filter(
            mediaData => mediaData.id === mediaImageId.relationships.field_media_image.data.id
          )[0];
          imageData.url = mediaFile.links && mediaFile.links.tile && mediaFile.links.tile.href;
        }
        return imageData;
      },

      // eslint-disable-next-line no-unused-vars
      getCategories(item) {
        const data = [];

        this.included.map(inc => {
          data.push(inc);

          return inc;
        });
        return data;
      },

      categoryClicked(cat) {
        EventBus.$emit('categorySelected', cat);
        window.scrollTo(0, 0);
      },

      processData(data) {
        data.forEach(item => {
          this.modifiedData.push({
            ...item,
            link: this.getItemLink(item),
            imageTeaser: this.getImageTileInformation(item),
            categories: this.getCategories(item),
            themeColour: this.setThemeColour(),
          });
        });
      },

      loadItems() {
        this.loadMoreIsDisabled = false;
        this.items = this.modifiedData;
        if (!this.links.next) {
          this.loadMoreIsDisabled = true;
        }
      },

      loadMoreItems() {
        if (!this.loadMoreIsDisabled && this.links.next) {
          // could trigger loader here too
          this.loadMoreIsDisabled = true;
          this.$http
            .get(this.links.next.href.replace('http://', 'https://'), { requestHeaders })
            .then(response => {
              this.included = [...this.included, ...response.body.included];
              this.links = response.body.links;
              this.processData(response.body.data);
              this.loadItems();
            })
            .catch(err => console.log(err)); // eslint-disable-line no-console
        }
      },

      getPostsByCat() {
        const filter = '[field_category_industry.id][value]';

        const endpoint =
          this.selectedCategory === 'all' || !this.selectedCategory
            ? caseStudyEndpoint
            : `${caseStudyEndpoint}&filter${filter}=${this.selectedCategory}`;

        this.$http.get(endpoint, { requestHeaders }).then(response => {
          // reset data
          this.modifiedData = [];
          this.items = [];
          this.included = response.body.included;
          this.links = response.body.links;
          this.processData(response.body.data);
          this.loadItems();
        });
      },

      filterByCategory(endpoint) {
        const filter = '[field_category_industry.id][value][]';
        const terms = categoryIndustry.split(',');

        if (categoryIndustry) {
          let filterString = '&filter[field_category_industry.id][operator]=IN';

          for (const term of terms) {
            filterString = `${filterString}&filter${filter}=${term}`;
          }
          return `${endpoint}${filterString}`;
        }
        return endpoint;
      },
    },

    mounted() {
      const endpoint = this.filterByCategory(caseStudyEndpoint);

      this.$http.get(endpoint, { requestHeaders }).then(response => {
        this.included = response.body.included;
        this.links = response.body.links;
        this.processData(response.body.data);
        this.loadItems();
      });
    },

    created() {
      EventBus.$on('categorySelected', cat => {
        this.selectedCategory = cat;
        this.getPostsByCat();
      });
    },
  });
});
